var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 200,
    viewBox: "0 0 1440 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46596 0H1440.16V191.844C1440.16 191.844 1333.41 204.889 1173.28 197.983C1013.15 191.077 960.766 172.711 821.586 176.496C682.406 180.282 616.058 197.216 341.689 191.844C67.3194 186.472 -31.9526 160.19 -31.9526 160.19L3.46596 0Z",
    fill: "#0D8B5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.3489 174.578L-40.9321 163.835C-73.1913 145.866 -120.749 108.047 -52.9046 100.527C31.9005 91.1262 69.4545 108.645 171.579 116.449C249.401 122.397 211.987 118.56 371.62 119.903C499.326 120.977 515.955 169.207 508.306 193.187C485.691 193.443 423.201 193.801 354.16 193.187C285.119 192.573 125.519 180.526 54.3489 174.578Z",
    fill: "url(#paint0_linear_668_128)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.238 0.383545H6.95767C-101.626 19.504 -372.869 34.0714 -112.268 47.5772C148.333 61.083 324.395 30.7588 320.238 0.383545Z",
    fill: "url(#paint1_linear_668_128)",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M862.492 0H1499.76C1521.45 26.98 1512.07 62.5437 1480.41 85.6746C1445.24 111.377 1539.04 163.909 1374.89 172.026C1240.04 178.693 1161.06 161.436 1116.93 123.101C1082.93 93.5657 1085.27 88.6056 1007.89 51.1793C913.691 5.62448 876.367 6.91409 862.492 0Z",
    fill: "url(#paint2_linear_668_128)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M1250.1 199.325C1306.77 201.013 1402.42 194.273 1443.16 190.692C1452.3 170.996 1451.54 129.763 1443.16 127.767C1432.68 125.273 1396.39 138.666 1319.44 145.225C1227.15 153.092 1207.7 133.907 1122.39 137.743C1036.94 141.586 1012.15 186.663 1027.61 187.431C1039.98 188.045 1087.97 192.547 1110.42 194.721C1133.37 195.552 1193.43 197.637 1250.1 199.325Z",
    fill: "url(#paint3_linear_668_128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_128",
    x1: -87.4377,
    y1: 145.675,
    x2: 509.867,
    y2: 145.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30D897"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_668_128",
    x1: -222,
    y1: 25.632,
    x2: 320.31,
    y2: 25.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0126127,
    stopColor: "#003420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DBC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_668_128",
    x1: 862.492,
    y1: 86.7135,
    x2: 1511.52,
    y2: 86.7135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ECC88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#055229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_668_128",
    x1: 1023.29,
    y1: 163.527,
    x2: 1449.73,
    y2: 163.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#398366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.213ef31fcaf8e5c019f42f9e4982f764.svg";
export { ForwardRef as ReactComponent };